import { request } from '../axios/sassbff'

// #获取密码控件初始化数据
export async function PwdInitTicket(
  params: {
    appId: string
    ticket: string
  },
  options?: { [key: string]: any },
): Promise<APISdpSecurity.ApiDataResponsePwdParamInitVO_> {
  return request('/api/pwd/init', {
    method: 'POST',
    data: params,
    ...(options || {}),
  })
}
